<template>
  <div class="footer" :class="{'index': pageName=='Index'}">
    <div class="content" v-if="pageName=='Index'">
      <p class="text">CopyrightC 2017-2025 kjcxchina.com 京icp备16012224号 Reserved</p>
      <p class="text">主办单位：中国金融工会经济技术部</p>
      <p class="text">技术支持： 中工科创</p>
    </div>
    <div class="content" v-else>
      <div class="top">
        <div class="left">
          <p class="title">联系我们</p>
          <p class="text phone">010-66278647</p>
          <p class="text email">jjgzzb@sina.com</p>
          <p class="text addr">北京市西城区金融大街15号鑫茂大厦</p>
        </div>
        <div class="right">
          <img class="img" src="@/assets/ewm_02.jpg">
          <p class="img-title">金融工运</p>
        </div>
      </div>
      <div class="bottom">CopyrightC 2017-2025 kjcxchina.com 京icp备16012224号 Reserved</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pc-footer',
  data() {
    return {
      pageName: ''
    }
  },
  mounted() {
    this.pageName = this.$route.name;
  },
  watch: {
    //监听路由
    $route() {
      this.pageName = this.$route.name;
    }
  },
}
</script>
<style lang="scss" scoped>
.footer{
  width: 100%;
  padding: 40px 0;
  background-color: gray;
  .content{
    width: 1200px;
    color: #fff;
    margin: 0 auto;
  }
  .top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 22px;
  }
  .title{
    color: #fff;
    font-size: 24px;
    font-weight: bold;
    padding-bottom: 14px;
  }
  .text{
    height: 17px;
    line-height: 17px;
    font-size: 14px;
    padding-left: 36px;
    margin-top: 16px;
    &.phone{
      background: url('@/assets/phone2.png') no-repeat 4px center/auto 100%;
    }
    &.email{
      background: url('@/assets/email2.png') no-repeat 4px center/13px;
    }
    &.addr{
      background: url('@/assets/addr2.png') no-repeat 4px center/auto 100%;
    }
  }
  .img{
    width: 124px;
  }
  .img-title{
    font-size: 16px;
    text-align: center;
    padding-top: 18px;
  }
  .bottom{
    padding-top: 18px;
    border-top: 2px solid #979797;
    text-align: center;
  }
  &.index{
    padding: 170px 0 120px;
    background: url('@/assets/footer.png') no-repeat center bottom/100% 100%;
    .text{
      text-align: center;
      margin: 0;
      padding: 0;
      margin-bottom: 6px;
    }
  }
}

</style>
